"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2645],{

/***/ 44300:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

const pageListAdmin = {
    adminHome: {
        text: "ホーム",
        url: "/admin"
    },
    adminListCompany: {
        text: "企業管理",
        url: "/admin/master/companies"
    },
    adminCreateCompany: {
        text: "企業登録",
        url: "/admin/master/companies/create"
    },
    adminOfficer: {
        text: "議員管理",
        url: "/admin/master/officer-management"
    },
    adminOfficerListCompany: {
        text: "議員登録",
        url: "/admin/master/officer-management/companies"
    },
    adminMeetingList: {
        text: "会議管理",
        url: "/admin/meetings"
    },
    adminCreateMeeting: {
        text: "会議登録",
        url: "/admin/meetings/create"
    },
    adminTemplateMeetingList: {
        text: "会議テンプレート一覧",
        url: "/admin/template-meetings"
    },
    adminCreateTemplateMeeting: {
        text: "会議テンプレート登録・編集",
        url: "/admin/template-meetings/create"
    },
    adminListExport: {
        text: "ファイルダウンロード",
        url: "/admin/exports"
    },
    adminChangePassword: {
        text: "パスワードを変更する",
        url: "/admin/change-password"
    },
    adminChangeProfile: {
        text: "プロフィール変更",
        url: "/admin/update-profile"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (pageListAdmin);


/***/ }),

/***/ 29910:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

const pageListCompany = {
    companyHome: {
        text: "会議一覧",
        url: "/company/meetings"
    },
    companyChangePassword: {
        text: "パスワードを変更する",
        url: "/company/change-password"
    },
    companyChangeProfile: {
        text: "プロフィール変更",
        url: "/company/update-profile"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (pageListCompany);


/***/ }),

/***/ 22645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ app_layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(51857);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/mobx-react-lite/es/index.js + 16 modules
var es = __webpack_require__(71217);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/stores/hooks/index.ts
var hooks = __webpack_require__(33654);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/containers/app-layout/app-footer/index.tsx


function AppFooter(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
            className: "footer-container bg-[#4169E1] h-[50px] flex items-center justify-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-xs text-[#fff]",
                    children: "\xa9 ".concat(dayjs_min_default()().year(), " YCCI CONFERENCE")
                }),
                children
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/UserOutlined.js + 1 modules
var UserOutlined = __webpack_require__(87547);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/KeyOutlined.js + 1 modules
var KeyOutlined = __webpack_require__(12119);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/ExportOutlined.js + 1 modules
var ExportOutlined = __webpack_require__(58638);
// EXTERNAL MODULE: ./node_modules/antd/es/menu/index.js + 6 modules
var es_menu = __webpack_require__(99709);
// EXTERNAL MODULE: ./node_modules/antd/es/dropdown/index.js + 2 modules
var dropdown = __webpack_require__(38504);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./public/svg/menu.svg
var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.57895C0 0.706919 0.479695 0 1.07143 0L23.9286 0C24.5203 0 25 0.706919 25 1.57895C25 2.45098 24.5203 3.15789 23.9286 3.15789H1.07143C0.479695 3.15789 0 2.45098 0 1.57895Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.0008C0 9.12879 0.479695 8.42188 1.07143 8.42188H23.9286C24.5203 8.42188 25 9.12879 25 10.0008C25 10.8729 24.5203 11.5798 23.9286 11.5798H1.07143C0.479695 11.5798 0 10.8729 0 10.0008Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18.4195C0 17.5475 0.479695 16.8406 1.07143 16.8406H23.9286C24.5203 16.8406 25 17.5475 25 18.4195C25 19.2916 24.5203 19.9985 23.9286 19.9985H1.07143C0.479695 19.9985 0 19.2916 0 18.4195Z",
    fill: "#333333"
  })));
};
/* harmony default export */ var svg_menu = (SvgMenu);
// EXTERNAL MODULE: ./src/aws-exports.js
var aws_exports = __webpack_require__(10500);
// EXTERNAL MODULE: ./src/common/helpers/index.tsx + 11 modules
var helpers = __webpack_require__(21787);
// EXTERNAL MODULE: ./src/common/helpers/page/admin.ts
var admin = __webpack_require__(44300);
// EXTERNAL MODULE: ./src/common/helpers/page/company.ts
var company = __webpack_require__(29910);
// EXTERNAL MODULE: ./src/types/role.ts
var types_role = __webpack_require__(63091);
// EXTERNAL MODULE: ./src/common/contexts/session_manager.tsx + 1 modules
var session_manager = __webpack_require__(58751);
;// CONCATENATED MODULE: ./src/containers/app-layout/app-header/index.tsx














const AppHeader = ()=>{
    const store = (0,hooks/* useLayoutStore */.E_)();
    const auth = (0,hooks/* useAuthStore */.tN)();
    const sessionManager = (0,session_manager/* useSessionManager */.l)();
    let accountName;
    if (true) {
        accountName = localStorage.getItem("CognitoIdentityServiceProvider.".concat(aws_exports/* default.aws_user_pools_web_client_id */.Z.aws_user_pools_web_client_id, ".LastAuthUser"));
    }
    const handleLogout = async ()=>{
        await auth.logout().then(()=>{
            sessionManager.setUserSession({
                cci_code: null,
                username: null,
                user_type: null
            });
            sessionStorage.clear();
            location.href = "/";
        });
    };
    const handlePushToChangePasswordPage = ()=>{
        const { role  } = auth;
        if (role === types_role/* ROLE.SUPER_ADMIN */.H.SUPER_ADMIN || role === types_role/* ROLE.ADMIN */.H.ADMIN) {
            router_default().push({
                pathname: "".concat(admin/* default.adminChangePassword.url */.Z.adminChangePassword.url)
            });
        } else if (role === types_role/* ROLE.COMPANY */.H.COMPANY) {
            router_default().push({
                pathname: "".concat(company/* default.companyChangePassword.url */.Z.companyChangePassword.url)
            });
        }
    };
    const handlePushToChangeProfilePage = ()=>{
        const { role  } = auth;
        if (role === types_role/* ROLE.SUPER_ADMIN */.H.SUPER_ADMIN || role === types_role/* ROLE.ADMIN */.H.ADMIN) {
            router_default().push({
                pathname: "".concat(admin/* default.adminChangeProfile.url */.Z.adminChangeProfile.url)
            });
        } else if (role === types_role/* ROLE.COMPANY */.H.COMPANY) {
            router_default().push({
                pathname: "".concat(company/* default.companyChangeProfile.url */.Z.companyChangeProfile.url)
            });
        }
    };
    const items = [
        {
            label: "プロフィール変更",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserOutlined/* default */.Z, {}),
            onClick: ()=>handlePushToChangeProfilePage(),
            key: "changeProfile"
        },
        {
            label: "パスワード変更",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyOutlined/* default */.Z, {}),
            onClick: ()=>handlePushToChangePasswordPage(),
            key: "changePassword"
        },
        {
            label: "ログアウト",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExportOutlined/* default */.Z, {}),
            onClick: ()=>handleLogout(),
            key: "logout"
        }
    ];
    const menu = /*#__PURE__*/ (0,jsx_runtime.jsx)(es_menu/* default */.Z, {
        items: items
    });
    var _checkRedirect;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "header flex h-[60px] justify-between items-center p-5 bg-[#4169E1] shadow-[0_4_20_rgba(0,0,0,0.1)] relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (_checkRedirect = (0,helpers/* checkRedirect */.D$)(auth.role)) !== null && _checkRedirect !== void 0 ? _checkRedirect : "/login",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/logo-lg.png",
                                        className: "md:w-[290px] md:h-[50px] w-[200px]",
                                        alt: "logo"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "hidden lg:block text-base text-white font-bold",
                                children: auth.companyName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-xs text-white font-bold",
                            children: [
                                "試験運用中",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "ページの表示に時間が掛かる場合がございます"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "cursor-pointer",
                            onClick: store.open,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg_menu, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "text-base text-white font-bold",
                    children: [
                        "試験運用中",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "ページの表示に時間が掛かる場合がございます"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden lg:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "https://drive.google.com/file/d/1Lx6VtTjP0f7NIT8CcgoZCvfQT9NOEUOy/view?usp=share_link",
                            target: "_blank",
                            className: "text-base text-white font-bold w-[max-content] mr-[60px]",
                            children: "ヘルプ"
                        }),
                        !!auth.isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* default.Button */.Z.Button, {
                            overlay: menu,
                            trigger: [
                                "click"
                            ],
                            children: accountName
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "absolute bottom-[-40px] md:bottom-[-55px] left-9 md:left-20 lg:hidden text-xl md:text-3xl text-primary font-bold",
                children: auth.companyName
            })
        ]
    });
};
/* harmony default export */ var app_header = ((0,es/* observer */.Pi)(AppHeader));

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CloseCircleOutlined.js + 1 modules
var CloseCircleOutlined = __webpack_require__(18429);
;// CONCATENATED MODULE: ./src/containers/app-layout/app-header/menu-mobile.tsx










const MenuMobile = ()=>{
    const store = (0,hooks/* useLayoutStore */.E_)();
    const auth = (0,hooks/* useAuthStore */.tN)();
    const handlePushToChangePasswordPage = ()=>{
        const { role  } = auth;
        if (role === types_role/* ROLE.SUPER_ADMIN */.H.SUPER_ADMIN || role === types_role/* ROLE.ADMIN */.H.ADMIN) {
            router_default().push({
                pathname: "".concat(admin/* default.adminChangePassword.url */.Z.adminChangePassword.url)
            });
        } else if (role === types_role/* ROLE.COMPANY */.H.COMPANY) {
            router_default().push({
                pathname: "".concat(company/* default.companyChangePassword.url */.Z.companyChangePassword.url)
            });
        }
        store.close();
    };
    const handlePushToChangeProfilePage = ()=>{
        const { role  } = auth;
        if (role === types_role/* ROLE.SUPER_ADMIN */.H.SUPER_ADMIN || role === types_role/* ROLE.ADMIN */.H.ADMIN) {
            router_default().push({
                pathname: "".concat(admin/* default.adminChangeProfile.url */.Z.adminChangeProfile.url)
            });
        } else if (role === types_role/* ROLE.COMPANY */.H.COMPANY) {
            router_default().push({
                pathname: "".concat(company/* default.companyChangeProfile.url */.Z.companyChangeProfile.url)
            });
        }
        store.close();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-b897115645d939af" + " " + ((0,clsx_m/* default */.Z)("page-mobile-menu flex justify-end", {
            open: store.isOpen
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-b897115645d939af" + " " + "page-mobile-menu-wrapper py-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-b897115645d939af" + " " + "mb-[60px]flex items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: store.close,
                            className: "jsx-b897115645d939af" + " " + "p-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseCircleOutlined/* default */.Z, {
                                width: 20,
                                height: 20
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-b897115645d939af" + " " + "page-mobile-menu-content",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "jsx-b897115645d939af" + " " + "menu-content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "jsx-b897115645d939af" + " " + "menu-item",
                                children: [
                                    !!auth.isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                onClick: handlePushToChangeProfilePage,
                                                className: "jsx-b897115645d939af" + " " + "menu-link flex items-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "jsx-b897115645d939af" + " " + "ml-2 text-sm font-medium leading-[20px]",
                                                    children: "プロフィール変更"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                onClick: handlePushToChangePasswordPage,
                                                className: "jsx-b897115645d939af" + " " + "menu-link flex items-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "jsx-b897115645d939af" + " " + "ml-2 text-sm font-medium leading-[20px]",
                                                    children: "パスワード変更"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://drive.google.com/file/d/1Lx6VtTjP0f7NIT8CcgoZCvfQT9NOEUOy/view?usp=share_link",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        className: "jsx-b897115645d939af" + " " + "menu-link flex items-center ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "jsx-b897115645d939af" + " " + "ml-2 mb-2 text-sm font-medium leading-[20px]",
                                            children: "ヘルプ"
                                        })
                                    }),
                                    !!auth.isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: ()=>{
                                                auth.logout();
                                                store.close();
                                            },
                                            className: "jsx-b897115645d939af" + " " + "menu-link flex items-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "jsx-b897115645d939af" + " " + "ml-2 text-sm font-medium leading-[20px] text-[#ff0000]",
                                                children: "ログアウト"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "b897115645d939af",
                children: '.page-mobile-menu.jsx-b897115645d939af{position:fixed;right:-200%;top:0;bottom:0;-webkit-transition:all.3s ease-in-out;-moz-transition:all.3s ease-in-out;-o-transition:all.3s ease-in-out;transition:all.3s ease-in-out;z-index:999;width:100%}.page-mobile-menu.open.jsx-b897115645d939af{right:0}.page-mobile-menu.open.jsx-b897115645d939af::after{content:"";position:absolute;top:0;left:0;right:0;bottom:0;background-color:rgba(51,51,51,.5);pointer-events:none}.page-mobile-menu-wrapper.jsx-b897115645d939af{width:90%;max-width:15rem;max-height:100vh;z-index:99;position:relative;overflow-y:auto;background-color:#fff;padding-bottom:.625rem}.page-mobile-menu-content.jsx-b897115645d939af{width:100%;height:-webkit-calc(100% - 6.875rem);height:-moz-calc(100% - 6.875rem);height:calc(100% - 6.875rem)}.page-mobile-menu-header.jsx-b897115645d939af{background-color:#faf9f8;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;height:3.125rem;padding:0 1.25rem}@media(min-width:1024px){.page-desktop-menu.jsx-b897115645d939af{display:block;width:17.5rem}.page-mobile-menu.jsx-b897115645d939af{display:none}}'
            })
        ]
    });
};
/* harmony default export */ var menu_mobile = ((0,es/* observer */.Pi)(MenuMobile));

;// CONCATENATED MODULE: ./src/containers/app-layout/index.tsx










/* harmony default export */ var app_layout = ((0,es/* observer */.Pi)(function AppLayout(param) {
    let { children , className , minWidth =true , noPadding =false  } = param;
    const authStore = (0,hooks/* useAuthStore */.tN)();
    (0,react.useEffect)(()=>{
        authStore.checkAuth();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "viewport",
                    content: "width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0",
                    className: "jsx-d3f371e76785bd69"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-d3f371e76785bd69" + " " + "flex flex-col min-h-[100vh]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(app_header, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        className: "jsx-d3f371e76785bd69" + " " + ((0,clsx_m/* default */.Z)("flex-1 py-10 px-2 md:py-[60px] md:px-20", {
                            "!overflow-x-scroll": minWidth,
                            "md:px-0 px-0": noPadding
                        }) || ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_mobile, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-d3f371e76785bd69" + " " + ((0,clsx_m/* default */.Z)("page-layout-children", className, {
                                    "!min-w-[950px]": minWidth
                                }) || ""),
                                children: children
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppFooter, {})
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "d3f371e76785bd69",
                children: ".logo-mobile.jsx-d3f371e76785bd69{font-weight:800!important;font-size:36px;line-height:49px;letter-spacing:.1em}@media(max-width:575.98px){.page-layout.ant-layout{-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}}.menu-item.jsx-d3f371e76785bd69{font-size:.6875rem;font-weight:700;padding:0rem 1.75rem;position:relative;margin-bottom:25px}.menu-link.jsx-d3f371e76785bd69{color:#003b54;font-size:14px;font-weight:500}"
            })
        ]
    });
}));


/***/ })

}]);